import { render, staticRenderFns } from "./userCoverPicture.vue?vue&type=template&id=2f2d8f8e&"
import script from "./userCoverPicture.vue?vue&type=script&lang=js&"
export * from "./userCoverPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports